import { useActionButtonContent, useIconButtonContent } from "../hooks/useButtonContent"
import { IconButton as IconButtonComponent, IconButtonProps } from "./IconButton"
import { ActionButton as ActionButtonComponent, ActionButtonProps } from "./ActionButton"
import { useGetCopyButton } from "@hydrologiq/shared/providers/helpers/useCopy"
import { IconButtonContent } from "../types/button-content"

export const IconButton = IconButtonComponent
export const ActionButton = ActionButtonComponent

export const EditButton = (props: IconButtonProps) => {
  const name = "edit"
  const copy = useGetCopyButton(name)
  const content = useIconButtonContent(name, copy)
  return <IconButton {...props} context={content} />
}

export const ExploreButton = (props: IconButtonProps) => {
  const name = "explore"
  const copy = useGetCopyButton(name)
  const content = useIconButtonContent(name, copy)
  return <IconButton {...props} context={content} />
}

export const StatusChangeButton = (props: IconButtonProps) => {
  const name = "changeStatus"
  const copy = useGetCopyButton(name)
  const content = useIconButtonContent(name, copy)
  return <IconButton {...props} context={content} />
}

export const MonitorButton = (props: IconButtonProps) => {
  const name = "monitor"
  const copy = useGetCopyButton(name)
  const content = useIconButtonContent(name, copy)
  return <IconButton {...props} context={content} />
}

export const LogButton = (props: IconButtonProps) => {
  const name = "log"
  const copy = useGetCopyButton(name)
  const content = useIconButtonContent(name, copy)
  return <IconButton {...props} context={content} />
}

export const SaveButton = (props: IconButtonProps) => {
  const name = "save"
  const copy = useGetCopyButton(name)
  const content = useIconButtonContent(name, copy)
  return <IconButton {...props} context={content} />
}

export const NewButton = (props: IconButtonProps & { context?: IconButtonContent } = {}) => {
  const name = "new"
  const copy = useGetCopyButton(name)
  let content = useIconButtonContent(name, copy)
  if (props.context) {
    content = { ...content, ...props.context }
  }
  return <IconButton {...props} context={content} />
}

export const LocationHistoryButton = (props: IconButtonProps) => {
  const name = "locationHistory"
  const copy = useGetCopyButton(name)
  const content = useIconButtonContent(name, copy)
  return <IconButton {...props} context={content} />
}

export const DeleteButton = (props: IconButtonProps) => {
  const name = "delete"
  const copy = useGetCopyButton(name)
  const content = useIconButtonContent(name, copy)
  return <IconButton {...props} context={content} />
}

export const BillButton = (props: ActionButtonProps) => {
  const name = "bill"
  const copy = useGetCopyButton(name)
  const content = useActionButtonContent(name, copy)
  return <ActionButton {...props} context={content} />
}

export const CancelButton = (props: ActionButtonProps) => {
  const name = "cancel"
  const copy = useGetCopyButton(name)
  let content = useActionButtonContent(name, copy)
  if (props.context) {
    content = { ...content, ...props.context }
  }
  return <ActionButton {...props} context={content} />
}

export const CreateButton = (props: ActionButtonProps) => {
  const name = "create"
  const copy = useGetCopyButton(name)
  let content = useActionButtonContent(name, copy)
  if (props.context) {
    content = { ...content, ...props.context }
  }
  return <ActionButton {...props} context={content} />
}

export const UpdateButton = (props: ActionButtonProps) => {
  const name = "update"
  const copy = useGetCopyButton(name)
  let content = useActionButtonContent(name, copy)
  if (props.context) {
    content = { ...content, ...props.context }
  }
  return <ActionButton {...props} context={content} />
}

export const ChangeButton = (props: ActionButtonProps) => {
  const name = "change"
  const copy = useGetCopyButton(name)
  const content = useActionButtonContent(name, copy)
  return <ActionButton {...props} context={content} />
}

export const RemoveButton = (props: ActionButtonProps) => {
  const name = "remove"
  const copy = useGetCopyButton(name)
  const content = useActionButtonContent(name, copy)
  return <ActionButton {...props} context={content} />
}

export const UnassignButton = (props: ActionButtonProps) => {
  const name = "unassign"
  const copy = useGetCopyButton(name)
  const content = useActionButtonContent(name, copy)
  return <ActionButton {...props} context={content} />
}

export const AssignButton = (props: ActionButtonProps) => {
  const name = "assign"
  const copy = useGetCopyButton(name)
  const content = useActionButtonContent(name, copy)
  return <ActionButton {...props} context={props.context || content} />
}

export const DownloadCSVButton = (props: ActionButtonProps) => {
  const name = "downloadCSV"
  const copy = useGetCopyButton(name)
  const content = useActionButtonContent(name, copy)
  return <ActionButton {...props} context={content} />
}

export const FilterButton = (props: ActionButtonProps) => {
  const name = "filter"
  const copy = useGetCopyButton(name)
  const content = useActionButtonContent(name, copy)
  return <ActionButton {...props} context={props.context || content} />
}

export const CreateSystemButton = (props: ActionButtonProps) => {
  const name = "createSystem"
  const copy = useGetCopyButton(name)
  const content = useActionButtonContent(name, copy)
  return <ActionButton {...props} context={content} />
}

export const ScheduleServiceButton = (props: ActionButtonProps) => {
  const name = "scheduleService"
  const copy = useGetCopyButton(name)
  const content = useActionButtonContent(name, copy)
  return <ActionButton {...props} context={content} />
}

export const ArchiveButton = (props: ActionButtonProps) => {
  const name = "archive"
  const copy = useGetCopyButton(name)
  const content = useActionButtonContent(name, copy)
  return <ActionButton {...props} context={props.context || content} />
}

export const CloseButton = (props: IconButtonProps) => {
  const name = "close"
  const copy = useGetCopyButton(name)
  let content = useIconButtonContent(name, copy)
  if (props.context) {
    content = { ...content, ...props.context }
  }
  return <IconButton {...props} context={content} />
}

export const CheckButton = (props: IconButtonProps) => {
  const name = "check"
  const copy = useGetCopyButton(name)
  const content = useIconButtonContent(name, copy)
  return <IconButton {...props} context={content} />
}

export const CollapseButton = (props: IconButtonProps) => {
  const name = "collapse"
  const copy = useGetCopyButton(name)
  const content = useIconButtonContent(name, copy)
  return <IconButton {...props} context={content} />
}

export const ExpandButton = (props: IconButtonProps) => {
  const name = "expand"
  const copy = useGetCopyButton(name)
  const content = useIconButtonContent(name, copy)
  return <IconButton {...props} context={content} />
}

export const CreateSiteButton = (props: ActionButtonProps) => {
  const name = "createSite"
  const copy = useGetCopyButton(name)
  const content = useActionButtonContent(name, copy)
  return <ActionButton {...props} context={content} />
}

export const CreateLocationButton = (props: ActionButtonProps) => {
  const name = "createLocation"
  const copy = useGetCopyButton(name)
  const content = useActionButtonContent(name, copy)
  return <ActionButton {...props} context={content} />
}

export const NewLocationButton = (props: ActionButtonProps) => {
  const name = "newLocation"
  const copy = useGetCopyButton(name)
  const content = useActionButtonContent(name, copy)
  return <ActionButton {...props} context={content} />
}

export const SelectLocationButton = (props: ActionButtonProps) => {
  const name = "selectLocation"
  const copy = useGetCopyButton(name)
  const content = useActionButtonContent(name, copy)
  return <ActionButton {...props} context={content} />
}

export const ResetLocationButton = (props: ActionButtonProps) => {
  const name = "resetLocation"
  const copy = useGetCopyButton(name)
  const content = useActionButtonContent(name, copy)
  return <ActionButton {...props} context={content} />
}

export const AssignLocationButton = (props: ActionButtonProps) => {
  const name = "assignLocation"
  const copy = useGetCopyButton(name)
  const content = useActionButtonContent(name, copy)
  return <ActionButton {...props} context={content} />
}

export const RefreshButton = (props: IconButtonProps) => {
  const name = "refresh"
  const copy = useGetCopyButton(name)
  const content = useIconButtonContent(name, copy)
  return <IconButton {...props} context={content} />
}

export const RefreshActionButton = (props: ActionButtonProps) => {
  const name = "refresh"
  const copy = useGetCopyButton(name)
  const content = useActionButtonContent(name, copy)
  return <ActionButton {...props} context={content} />
}

export const AddEventButton = (props: ActionButtonProps) => {
  const name = "addEvent"
  const copy = useGetCopyButton(name)
  const content = useActionButtonContent(name, copy)
  return <ActionButton {...props} context={content} />
}

export const AddActivityButton = (props: ActionButtonProps) => {
  const name = "addActivity"
  const copy = useGetCopyButton(name)
  const content = useActionButtonContent(name, copy)
  return <ActionButton {...props} context={content} />
}

export const ScheduleActivityButton = (props: ActionButtonProps) => {
  const name = "scheduleActivity"
  const copy = useGetCopyButton(name)
  const content = useActionButtonContent(name, copy)
  // Children will override the default label from content
  return <ActionButton {...props} context={content} />
}

export const ScheduleOrderButton = (props: ActionButtonProps) => {
  const name = "scheduleOrder"
  const copy = useGetCopyButton(name)
  const content = useActionButtonContent(name, copy)
  return <ActionButton {...props} context={content} />
}

export const ConfirmButton = (props: ActionButtonProps) => {
  const name = "confirm"
  const copy = useGetCopyButton(name)
  const content = useActionButtonContent(name, copy)
  return <ActionButton {...props} context={props.context || content} />
}

export const CompleteButton = (props: ActionButtonProps) => {
  const name = "complete"
  const copy = useGetCopyButton(name)
  const content = useActionButtonContent(name, copy)
  return <ActionButton {...props} context={content} />
}

export const BackButton = (props: ActionButtonProps) => {
  const name = "back"
  const copy = useGetCopyButton(name)
  const content = useActionButtonContent(name, copy)
  return <ActionButton {...props} context={content} />
}

export const StatusChangeActionButton = (props: ActionButtonProps) => {
  const name = "changeStatus"
  const copy = useGetCopyButton(name)
  const content = useActionButtonContent(name, copy)
  return <ActionButton {...props} context={content} />
}

export const CalendarButton = (props: IconButtonProps) => {
  const name = "calendar"
  const copy = useGetCopyButton(name)
  const content = useIconButtonContent(name, copy)
  return <IconButton {...props} context={content} />
}

export const InfoButton = (props: IconButtonProps) => {
  const name = "info"
  const copy = useGetCopyButton(name)
  const content = useIconButtonContent(name, copy)
  return <IconButton {...props} context={{ ...content, ...props.context }} />
}
